export default __webpack_public_path__ + "static/media/pencil.8aed4cb0.svg";